import { forwardRef, type Ref, type SVGProps } from "react";
const IconPrintOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M12.89 21h6.22a1 1 0 0 0 0-2h-6.22a1 1 0 0 0 0 2m0 4h6.22a1 1 0 0 0 0-2h-6.22a1 1 0 0 0 0 2" />
    <path d="M26 11a1 1 0 1 0 0 2 1 1 0 1 0 0-2" />
    <path d="M27 8h-2V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v5H5a3 3 0 0 0-3 3v10a1 1 0 0 0 1 1h4v7a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-7h4a1 1 0 0 0 1-1V11a3 3 0 0 0-3-3M9 4h14v4H9zm14 16v8H9V16h14zm5 0h-3v-5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v5H4v-9a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1z" />
  </svg>
);
const ForwardRef = forwardRef(IconPrintOutlineSVG);
ForwardRef.displayName = "IconPrintOutline";
export { ForwardRef as IconPrintOutline };
